export const audioFiles = {
  Melody1: '/audio/Melody1.wav',
  Melody2: '/audio/Melody2.wav',
  Melody3: '/audio/Melody3.wav',
  Melody4: '/audio/Melody4.wav',
  Melody5: '/audio/Melody5.wav',
};